import { ContractorAbridged } from './abridged/contractor-abridged'

export class Worker {
  id: number;
  login: string;
  firstName: string;
  lastName: string;
  name: string;
  email: string;
  phoneNumber: string;
  contractor: ContractorAbridged;
  authorities: string[];
  activated: boolean;
  deleted: boolean;

  public deserialize(input: any): this {
    this.id = input.id;
    this.login = input.login;
    this.firstName = input.firstName;
    this.lastName = input.lastName;
    this.name = input.firstName + ' ' + input.lastName;
    this.email = input.email;
    this.phoneNumber = input.workerUser.phoneNumber;
    this.activated = input.activated;
    this.deleted = input.workerUser.deleted;

    this.contractor = (new ContractorAbridged()).deserialize(input.workerUser.maintenance);
    this.authorities = input.authorities.map(a => a.name);

    return this;
  }
};
